module.exports = __webpack_public_path__ + "static/media/scenario.a3705e22.png";